import { FC } from 'react';
import { KeyedMutator } from 'swr';

import { CoverPageLoader } from '../../components/coverPage/CoverPageLoader';
import { AssetNotFound } from '../../components/errorPage/AssetNotFound';

import { useFetchSuperCoverPage, useOptimisticFavoriteToggle } from './hooks/useFetchSuperCoverPage';
import { SuperCoverPageMovie, SuperCoverPageSeries } from './contentStack.types';
import { StackedEpisodeOrMoviePage } from './StackedEpisodeOrMoviePage';
import { StackedSeriesPage } from './StackedSeriesPage';

export type StackedCoverPageProps = {
  id: string;
};

export const StackedCoverPage: FC<StackedCoverPageProps> = props => {
  const { data, error, isLoading, mutate } = useFetchSuperCoverPage(props);
  useOptimisticFavoriteToggle(mutate);

  if (error) {
    return <AssetNotFound contextInfo={`StackedCoverPage, error=${error?.message}`} />;
  }
  if (!data || isLoading) {
    return <CoverPageLoader />;
  }

  if (data.type === 'series') {
    return <StackedSeriesPage data={data} dataMutator={mutate as KeyedMutator<SuperCoverPageSeries>} />;
  } else {
    // Episode or Movie
    return (
      <StackedEpisodeOrMoviePage id={props.id} data={data} dataMutator={mutate as KeyedMutator<SuperCoverPageMovie>} />
    );
  }
};
